<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <!--<el-menu-item index="1" @click="toNewRouter('custom-payment-over-view')" >-->
        <!--<i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>-->
        <!--<span slot="title">概览</span>-->
      <!--</el-menu-item>-->
      <el-menu-item index="2" @click="toNewRouter('contract-template')" v-if="permissionCodes.indexOf('015001000') !== -1">
        <i class="el-icon-damai-contract"></i>
        <span slot="title">合同模板</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('notice-template')" v-if="permissionCodes.indexOf('015003000') !== -1">
        <i class="el-icon-damai-tongzhidan"></i>
        <span slot="title">通知单模板</span>
      </el-menu-item>
      <!-- <el-menu-item index="4" @click="toNewRouter('hatch-template')" v-if="permissionCodes.indexOf('015004000') !== -1">
        <i class="el-icon-damai-xieyi"></i>
        <span slot="title">孵化协议模板</span>
      </el-menu-item> -->
      <el-menu-item index="5" @click="toNewRouter('document-log')" v-if="permissionCodes.indexOf('015002000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->

    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: "custom-payment-over-view",
  2: "contract-template",
  3: "notice-template",
  4: "hatch-template",
  5: 'document-log'
});

export default {
  name: "epidemic-situation-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/Document/DocumentNav.vue